import { isPageHidden } from 'lib/utils/common'
/* global jQuery admgr espn espn_ui */
export const ads = {

  /**
   * [gamebreak Function to init the gamebreak video ad in gamepackage page]
   * @param  {[type]} props [includes all the data like gameId(integer), gamestatus(pre,post), sport(cricket)]
   * @return {[type]}        [description]
   */
  gamebreak: function (props) {

    let _ = window._
    let espn_ui = window.espn_ui
    let espn_util = window.espn_util

    espn.gamepackage = espn.gamepackage || {}

    /*
    creates markup for ooyala player if we want to run the ad
    after div#videoPlayer is removed from dom
    */
    if(props.hasOwnProperty('addplayerhtml') === true) {
      if(props.addplayerhtml) {
        addVideoPlayerDiv(props.addplayerhtml)
        return false
      }
    }

    //when show ad is false stop execution
    if(props.showad === false) {
      return false
    }

    let config = props
    let _gameId = props.gameId
    let _gamestatus = props.gamestatus
    let _sport = props.sport
    let _gamebreakstatus = props.gamebreakstatus

    if((_gamestatus !== 'in')) {
      return false
    }

    let cms = 'espn'
    if(espn.i18n.lang === 'es') {
      cms = 'deportes'
    } else if(_sport === 'soccer') {
      cms = 'intl'
    }

    let siteSectionTarget = `espn:gamepackage:${_sport}`
    let videoIdTarget = `espn:gamepackage:${_sport}`

    let playHook
    let adStartHook
    let completeHook
    let countdownHook
    let timeoutHook
    let fallbackTimeoutHook
    let _isIncompatibleBrowser = isIncompatibleBrowser()

    jQuery(document).on('page.render', onPageRender)

    function addVideoPlayerDiv(html) {
      let videoPlaceholderDiv = jQuery('#gamepackage-gamebreak').length
      if(html && (videoPlaceholderDiv === 0)) {
        jQuery('#videogamebreak').html('').append(html)
      }
    }

    let durationMessage = _.translate('Advertisement: Game coverage will resume in')
    let defaultMessage = _.translate('Advertisement: Game coverage will resume after ad is complete.')
    let MIN_TIME_BETWEEN_ADS = 5 // in mins

    /**
     * [onBeforeLoad Clear listeners if already created ]
     * @return {[type]} []
     */
    function onBeforeLoad() {
      if(playHook) { jQuery.unsubscribe(playHook) }
      if(adStartHook) { jQuery.unsubscribe(adStartHook) }
      if(completeHook) { jQuery.unsubscribe(completeHook) }
      jQuery(document).off('page.beforeload', onBeforeLoad)
      clearInterval(countdownHook)
      clearTimeout(timeoutHook)
      clearTimeout(fallbackTimeoutHook)
    }

    /**
     * [onAdStart Callback when the ad is started, to start countdown]
     * @param  {[type]} duration [time in seconds]
     * @return {[type]}          []
     */
    function onAdStart(duration) {
      clearTimeout(fallbackTimeoutHook)

      if(!isNaN(duration)) {
        countdown(parseInt(duration, 10))
      } else {
        jQuery('.video-ad-break-wrap .countdown').html(defaultMessage)
      }
    }

    /**
     * [countdown counts the number of seconds left when ad is playing]
     * @param  {[type]} duration [time in seconds]
     * @return {[type]}          []
     */
    function countdown(duration) {
      var start = duration,
        secondString = (start === 1) ? _.translate('second') : _.translate('seconds')

      clearInterval(countdownHook)
      jQuery('.video-ad-break-wrap .countdown').html(durationMessage + ' ' + start + ' ' + secondString)

      countdownHook = setInterval(function () {
        start--
        secondString = (start === 1) ? _.translate('second') : _.translate('seconds')
        jQuery('.video-ad-break-wrap .countdown').html(durationMessage + ' ' + start + ' ' + secondString)
        if(start <= 0) {
          clearInterval(countdownHook)
        }
      }, 1000)
    }
    /**
     * [remove Function to remove the container where video player ad will be loaded]
     * @return {[type]} []
     */
    function remove() {
      jQuery('#gamepackage-gamebreak').remove()
      clearInterval(countdownHook)
    }


    function isIncompatibleBrowser() {
      var USER_AGENT = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent || '',
        IS_EDGE = (/Edge/i).test(USER_AGENT),
        IS_CHROME = !IS_EDGE && (/Chrome/i).test(USER_AGENT),
        IS_ANDROID = (/Android/i).test(USER_AGENT),
        IS_SAFARI = (/Safari/i).test(USER_AGENT) && (/Mac OS X 10_/i).test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE,
        versionString = 'Version/',
        versionStringStart = USER_AGENT.indexOf(versionString),
        versionStringEnd = versionStringStart + versionString.length,
        versionStringNumber = USER_AGENT.substring(versionStringEnd, versionStringEnd + 4).replace(/\s/g, '')

      return IS_SAFARI && parseFloat(versionStringNumber) >= 11
    }

    /**
     * [initAd Function to init the ad based on cookie]
     * @return {[type]} []
     */
    const initAd = function () {
      let mq = espn_ui.media_query_in_use
      let type = 'Pre-Roll'
      let _show = false
      let timeout = 7000 // default timeout is 7s

      if(mq && mq !== 'mobile') {
        _show = true
        timeout = 0 // dont delay for pre-roll, show immediately
        if(_show === true) {
          // if we've shown an ad in the last 5 mins... don't show another one here...
          if((jQuery.cookie('gamebreak') !== '1' || jQuery.cookie('gamebreak') === 'show') && jQuery.cookie('gamebreak') !== 'hide') {
            timeoutHook = setTimeout(function () {
              // only show the ad if we aren't backed up with other plays ready to bet shown
              show(type)
            }, timeout)
          }
        }
      }

    }
    /**
     * [show Function to show the ad based on type]
     * @param  {[type]} type [Type of ad used; value can be "Pre-Roll", "Mid-Roll" and "Post-Roll"]
     * @return {[type]}      [returns the ad in the targeted container]
     */
    const show = function (type) {

      let targetReplaceIdTag = 'gbVideoPlayer'
      let adSet = cms

      /**
       * [insertAd Function to insert the Ad unit based on location]
       * @return {[type]} [creates OBJECT tag for video ad in the targetReplaceId]
       */
      let insertAd = function () {
        const adParams = {
          adUnit: type, //(String) Determines the playback position of the adSet.  Value can be "Pre-Roll", "Mid-Roll" and "Post-Roll".
          adSet: adSet, //(String) Indicates the adSetCode to be used. Values can be "espn", "deportes", "intl" or "intl-domestic".
          midSequence: 0,
          siteSection: siteSectionTarget, //(String) The Freewheel Site Section.
          videoId: videoIdTarget, //(String) Colon delimitted list of the first two parts of the siteSection.
          targetReplaceId: targetReplaceIdTag //(String) ID of div where the ooyala player will be loaded dynamically
        }

        //Don't load the ooyala player outside of the component if main div#gbVideoPlayer is not found
        if(jQuery('#'+targetReplaceIdTag).length === 0) {
          return false
        }

        if((jQuery.cookie('gamebreak') === '1') || (jQuery.cookie('gamebreak') === 'hide')) {
          return false
        }

        jQuery('#gamepackage-gamebreak').show()

        //console.log('=======AD HAS STARTED PLAYING======')

        espn.video.insertAd(adParams, cms)

        var expires = new Date()
        expires.setTime(expires.getTime() + MIN_TIME_BETWEEN_ADS * 60 * 1000)
        jQuery.cookie('gamebreak', '1', { expires: expires })

        // at this point we've inserted the video player..
        // if we don't hear anything from it (ie ad hasn't started)
        // within 15 seconds, remove it.
        fallbackTimeoutHook = setTimeout(remove, 15000)
      }
      //check for location, then load the ad based on location
      if(cms === 'intl') {
        var intlDomesticCountries = [ 'us', 'in' ]
        espn.geo.getLocation().done(function (loc) {
          var country_code = espn_util.find(loc || {}, [ 'country', 'isoCodeAlpha2' ] ) || ''
          adSet = intlDomesticCountries.indexOf(country_code) !== -1 ? 'intl-domestic' : cms
          insertAd()
        })
      } else {
        insertAd()
      }

    }
    /**
     * [init Init the ad based on gamestatus and if flash is available]
     * @return {[type]} []
     */
    function init() {
      if(_gamestatus === 'in' && (_isIncompatibleBrowser === false)) {
        playHook = jQuery.subscribe('gamepackage:play', initAd)
        // jQuery.subscribe('espn.video.error', remove);
        // jQuery.subscribe('espn.video.unavailable', remove);
        adStartHook = jQuery.subscribe('espn.video.ad.start', onAdStart)
        completeHook = jQuery.subscribe('espn.video.complete', remove)
        jQuery(document).on('page.beforeload', onBeforeLoad)

        initAd()
      }
    }
    /**
     * [onPageRender Function to call init, if game page on document load complete]
     * @return {[type]} [description]
     */
    function onPageRender() {
      if(config && (config.type === 'game' || config.type === 'match') && (typeof _gameId !== 'undefined')) {
        if(typeof _gamebreakstatus !== 'undefined') {
          init()
        }
      }
    }

    onPageRender()

  },

  inviewAdRevert: function () {
    let _independent = []
    let adClass = '.ad-slot.loaded'
    let $el
    _independent = jQuery('body').find(adClass)
    if(_independent.length > 0) {
      for(let i = 0, l = _independent.length; i < l; i++) {
        $el = _independent.eq(i)
        if($el.length === 1) {
          $el.removeClass('ad-slot loaded').addClass('ad-slot-independent')
        }
      }
    }
  },

  loadInViewAds : function (adblock = false, params = {}) {
    let _inview = [], disableInViewAdOnload = false
    if(adblock === true) {
      return false
    }
    const { pageType } = params

    if(pageType === 'commentary') {
      disableInViewAdOnload = true
    }

    function pageRender(/*e, url, html, data*/) {
      let adClass = '.ad-slot-independent'
      _inview = jQuery('body').find(adClass)
      if(_inview.length > 0) {
        registerInviewAds({
          refresh:true
        })
        adScrollevent('on')
      } else {
        adScrollevent('off')
      }
    }

    function adScrollevent(type) {
      try{
        let $window = jQuery(window)

        if(espn_ui.webview) {
          if(type === 'on') {
            window.onscroll = initInviewAds
          } else {
            window.onscroll = function () {}
          }
        } else {
          if(type === 'on') {
            $window.on('windowscroll.debounce.ads', initInviewAds)
          } else {
            $window.off('windowscroll.debounce.ads', initInviewAds)
          }
        }
      } catch(err) {
        console.log(err)
      }
    }

    function registerInviewAds(obj) {
      let found = false
      let $el
      for(let i = 0, l = _inview.length; i < l; i++) {
        $el = jQuery(_inview[i])
        if($el.length === 1 && !$el.hasClass('loaded') && isAdInViewport(getAdReqCatalystElement($el[0])) && !disableInViewAdOnload) {
          $el.addClass('ad-slot loaded').removeClass('ad-slot-independent')

          if(obj && obj.refresh === true) {
            admgr.registerSlot($el[0], espn.ads.config)
          }

          _inview.splice(i, 1)
          found = true
          break
        }
      }
      return found
    }


    function initInviewAds(force) {
      let found = false
      let $el
      
      for(let i = 0, l = _inview.length; i < l; i++) {
        $el = jQuery(_inview[i])
        if($el.length === 1 && !$el.hasClass('loaded') && (isAdInViewport(getAdReqCatalystElement($el[0])) || force === true)) {
          $el.addClass('ad-slot loaded').removeClass('ad-slot-independent')
          admgr.initSlot($el[0], espn.ads.config)
          _inview.splice(i, 1)
          found = true

          // we found the ad, no need to keep listening to scrolls
          if(_inview.length === 0) {
            adScrollevent('off')
          }
          break
        }
      }
      return found
    }


    function getAdReqCatalystElement(element) {
      return element.className.indexOf('native') > -1 ? element.previousElementSibling : element
    }

    function isAdInViewport(el) {

      let rect = el.getBoundingClientRect()
      if(rect.top === 0 && rect.bottom === 0) {
        return false
      }
      return (
        (rect.top >= 0 && (rect.top) <= (window.innerHeight || document.documentElement.clientHeight)) ||
        (rect.bottom >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
      )
    }

    pageRender()
  },

  updateKeyValue: function ( edition = {}, params = {}, meta ={}, pageState = '', kvevent = '', kvbattingteam = '' ) {
    if(edition.hasOwnProperty('isEspnCricinfo') === true) {
      if(edition.isEspnCricinfo && meta) {
        const { platform, pageType, league, gameId } = params
        let leagueName = (meta && meta.leagueName) || ''
        if(pageState === 'scoreboard') {
          leagueName = meta.title ? meta.title.substring(0, meta.title.lastIndexOf('-')) : ''
        }
        if(leagueName.length === 0) {
          leagueName = params.slug || ''
        }
        let kvObj = {}
        if(leagueName && (typeof leagueName === 'string')) {
          leagueName = leagueName.replace(/\W+/g, '')
          leagueName = leagueName.toLowerCase()
        }
        if( pageType === 'scores' ) {
          kvObj.kvpt = pageState
          kvObj.pgtyp = pageState
        } else if(pageType === 'standings') {
          kvObj.kvpt = 'pointstable'
        } else if(pageType === 'table') {
          kvObj.kvpt = 'table'
        } else {
          kvObj.kvpt = 'livescorecard'
          if(pageState === 'final') {
            kvObj.kvpt = 'archivedscorecard'
          }
          kvObj.kvsite = leagueName
          kvObj.pgtyp = 'game'
        }

        if(typeof platform !== 'undefined') {
          kvObj.kvos = platform
        }
        if(pageType === 'scores' && pageState === 'scoreboard') {
          kvObj.kvsite = leagueName
          kvObj.kvbrand = leagueName
        }
        if(pageType !== 'scores') {
          kvObj.kvsite = leagueName
          kvObj.kvbrand = ''
          kvObj.kvseriesid = league || ''
          kvObj.kvmatchid = gameId || ''
        }
        kvObj.kvevent = kvevent
        kvObj.kvbattingteam = kvbattingteam
        ads.updateAdsKvps(kvObj, pageType)
      }
    }
  },
  /**
  * Add key value pair for ads
  * @param {Object} kvObj key values details
  * @param {String} pageType page type info
  * @set key value pairs and pass to espn.ads.config.kvps
  * @return {undefined} undefined
  */
  updateAdsKvps: function ( kvObj = {}, pageType = '' ) {
    try{
      let kvps = espn.ads.config.kvps || []
      let adLevel = ''

      if(pageType.length > 0) {
        if( pageType === 'scores' ) {
          adLevel = 'espn.cricinfo.com/matches/liveindex'
        } else if(pageType === 'standings') {
          adLevel = 'espn.cricinfo.com/standings/series/' + kvObj.kvsite
        } else if(pageType === 'table') {
          adLevel = 'espn.cricinfo.com/table/series/' + kvObj.kvsite
        } else {
          adLevel = 'espn.cricinfo.com/game/' + pageType
        }
      }

      espn.ads.config.level = adLevel
      for(let key in kvObj) {
        if (kvObj.hasOwnProperty(key)) {

          let objIndex = kvps.findIndex((obj => obj.name == key))

          if(objIndex === -1 ) {
            kvps.push({
              'name' : key,
              'value' : kvObj[key]
            })
          } else if(objIndex > 1 ) {

            for (let k in kvps) {
              if (kvps.hasOwnProperty(k)) {
                if( kvps[k].name === key) {
                  kvps[k].value = kvObj[key]
                }
              }
            }
          }
        }
      }
    } catch(err) {
      console.log(err)
    }
  },

  init: function (adblock, edition={}) {
    if(adblock === true) {
      return false
    }

    // Begin CMS-enabled sponsored content providers setup
    let _ = window._ || {}
    let espn = window.espn || {}
    let espnI18N = espn.i18n || {}
    let sponsoredContentProviders = edition && edition.sponsoredContentProviders || []
    let numSponsoredContentProviders = sponsoredContentProviders.length
    let cmsEnabledSponsoredContentProviders = []
    let espnStorage = espn && espn.storage || {}
    let config = espn.ads.config
    // if cookie contains 'ESPN_PLUS' that means the fan has E+ and should not get ads
    const espnPlusEntitle = espnStorage && espnStorage.getItem('ESPN_PLUS') === 1 ? true : false
    if(espnPlusEntitle === true) {
      jQuery('.ad-slot').removeClass() // remove white space
      return false
    }
    for(let i = 0; i < numSponsoredContentProviders; i++) {
      let sponsoredContentProvider = sponsoredContentProviders[i]
      // We only care about the CMS flag because we rely on Reduxion edition configs
      // instead of sCore edition configs
      if(_.get(espnI18N, [ sponsoredContentProvider, 'cmsEnabled' ])) {
        cmsEnabledSponsoredContentProviders.push(sponsoredContentProvider)
      }
    }
    if(cmsEnabledSponsoredContentProviders.length) {
      espn.ads = espn.ads || {}
      espn.ads.config = espn.ads.config || {}
      espn.ads.config.cmsEnbldSpnsrdCntntPrvdrs = cmsEnabledSponsoredContentProviders.join(',')
    }
    // End CMS-enabled sponsored content providers setup
    let refreshRate = config.refreshRate || 0
    if (refreshRate > 0 && edition.isEspnCricinfo && !edition.isAsiaRegion) {
      refreshRate = config.refreshRateOther || 0
    }
    try{
      admgr.init({ ...config, refreshRate, refreshWhenVideoPlays: true })
    }catch(e) {
      console.error(e)
    }
  },
  get: function (type) {
    try {
      var arr = admgr.getGPTArray() || []
      for (var i=0,len = arr.length; i < len; i++) {
        if(arr[i].type === type) {
          return arr[i]
        }
      }
    }catch(e) {
      console.log(e)
    }
    return null
  },
  refresh: function (slot) {
    try {
      var ad = this.getAd(slot)
      if(ad !== null) {
        admgr.refresh([ ad ])
      }
    }catch(e) {
      console.log(e)
    }
  },
  refreshAdOnEvent: function (adSlot) {
    try {
      if(adSlot !== null) {
        admgr.initSlot(adSlot, espn.ads.config)
      }
    }catch(e) {
      console.log(e)
    }
  },
  refreshAll: function () {
    admgr.refreshAll()
  },
  getSlot: function (type) {

    const attrs = []

    attrs.push(
      `data-slot-type="${type}"`,
      `data-slot-kvps="pos=${type}"`
    )
    if(type === 'presbyHeader') {
      attrs.push(
        'class="scoreboard-dropdown-wrapper presby-ad react-ad ad-slot ad-slot-presby"',
        'data-exclude-bp="s"'
      )
    } else {
      attrs.push(
        `class="react-ad ad-slot ad-slot-${type}"`
      )
    }

    if(type === 'wallpaper') {
      attrs.push(
        'data-collapse-before-load="true"'
      )
    }

    if(type === 'overlay') {
      attrs.push(
        'data-out-of-page="true"'
      )
    }

    return `<div ${attrs.join(' ')} />`
  },
  unloadAds: function () {
    jQuery('.ad-slot').removeAttr('data-disabled').empty()
    admgr.resetDisabledTypes()
  }
}

export default ads



// WEBPACK FOOTER //
// ../app/lib/utils/ads.js